var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-toolbar-clipboard",
    },
    [
      _c(
        "courseware-collapsible-box",
        {
          attrs: {
            title: _vm.$gettext("Blöcke"),
            open: _vm.clipboardBlocks.length > 0,
          },
        },
        [
          _vm.clipboardBlocks.length > 0
            ? [
                _c(
                  "div",
                  {
                    staticClass: "cw-element-inserter-wrapper",
                  },
                  [
                    _c(
                      "draggable",
                      {
                        ref: "clipboardSortables",
                        staticClass: "cw-element-inserter-wrapper",
                        attrs: {
                          tag: "div",
                          role: "listbox",
                          handle: ".cw-sortable-handle-clipboard",
                          group: {
                            name: "blocks",
                            pull: "clone",
                            put: "false",
                          },
                          sort: false,
                          clone: _vm.cloneClipboard,
                          emptyInsertThreshold: 20,
                          sectionId: "0",
                        },
                        on: {
                          end: function end($event) {
                            return _vm.dropClipboardBlock($event)
                          },
                        },
                        model: {
                          value: _vm.clipboardBlocks,
                          callback: function callback($$v) {
                            _vm.clipboardBlocks = $$v
                          },
                          expression: "clipboardBlocks",
                        },
                      },
                      _vm._l(_vm.clipboardBlocks, function (clipboard, index) {
                        return _c("courseware-clipboard-item", {
                          key: index,
                          attrs: {
                            clipboard: clipboard,
                          },
                          on: {
                            inserted: function inserted($event) {
                              return _vm.$emit("blockAdded")
                            },
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button trash",
                    on: {
                      click: function click($event) {
                        return _vm.clearClipboard("courseware-blocks")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$gettext("Alle Blöcke aus Merkliste entfernen")
                        ) +
                        "\n            "
                    ),
                  ]
                ),
              ]
            : _c("courseware-companion-box", {
                attrs: {
                  mood: "pointing",
                  msgCompanion: _vm.$gettext(
                    "Die Merkliste enthält keine Blöcke."
                  ),
                },
              }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "courseware-collapsible-box",
        {
          attrs: {
            title: _vm.$gettext("Abschnitte"),
            open: _vm.clipboardContainers.length > 0,
          },
        },
        [
          _vm.clipboardContainers.length > 0
            ? [
                _c(
                  "div",
                  {
                    staticClass: "cw-element-inserter-wrapper",
                  },
                  [
                    _c(
                      "draggable",
                      {
                        ref: "clipboardContainerSortables",
                        staticClass: "cw-element-inserter-wrapper",
                        attrs: {
                          tag: "div",
                          role: "listbox",
                          handle: ".cw-sortable-handle-clipboard",
                          group: {
                            name: "description",
                            pull: "clone",
                            put: "false",
                          },
                          sort: false,
                          emptyInsertThreshold: 20,
                          clone: _vm.cloneClipboardContainer,
                        },
                        on: {
                          end: function end($event) {
                            return _vm.dropNewContainer($event)
                          },
                        },
                        model: {
                          value: _vm.clipboardContainers,
                          callback: function callback($$v) {
                            _vm.clipboardContainers = $$v
                          },
                          expression: "clipboardContainers",
                        },
                      },
                      _vm._l(
                        _vm.clipboardContainers,
                        function (clipboard, index) {
                          return _c("courseware-clipboard-item", {
                            key: index,
                            attrs: {
                              clipboard: clipboard,
                            },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button trash",
                    on: {
                      click: function click($event) {
                        return _vm.clearClipboard("courseware-containers")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$gettext(
                            "Alle Abschnitte aus Merkliste entfernen"
                          )
                        ) +
                        "\n            "
                    ),
                  ]
                ),
              ]
            : _c("courseware-companion-box", {
                attrs: {
                  mood: "pointing",
                  msgCompanion: _vm.$gettext(
                    "Die Merkliste enthält keine Abschnitte."
                  ),
                },
              }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.showDeleteClipboardDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.textDeleteClipboardTitle,
              question: _vm.textDeleteClipboardAlert,
              height: "200",
              width: "500",
            },
            on: {
              confirm: _vm.executeDeleteClipboard,
              close: _vm.closeDeleteClipboardDialog,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }